import $ from 'jquery';
import React,{useState,useEffect} from 'react';
import {GetImgCertUser_CBack,btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';

export function updMemeberReq(){
    GetImgCertUser_CBack(this,"#upd-member-form","update_profile",function(checkData,checkMsg,userMsg){
      if(checkData===-10){
        alert("Kindly fill required fields");
        return;
      }else {
        //Custom_Alert("Successfully Added",checkMsg,false);
        alert(checkMsg);
        $('#divEditProduct').modal('hide');
        window.location.reload();
      }
    });
}             
  
export const Comp_Edit_Matri_Member=(props)=>{
    
    useEffect(()=>{
        //setMyProfile(props.memberProfile);
    },[props.memberProfile])

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divUpdateMemeber" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Edit Product</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            {props.memberProfile.length>0?
            <form enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()" className="contact-form-style form-control11 " name="upd-member-form" id="upd-member-form">
    <input type="hidden" name="curl_type" id="curl_type" value="update_profile" />  
                <input type="hidden" name="m_type" id="m_type" value="update_profile" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type='hidden' name="member_token" id="member_token" value={btoa(props.memberProfile[0]["id"])}/>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Name:</strong></label>
                <input name="first_name" id="first_name" type="text" defaultValue={props.memberProfile[0]["mem_name"]} class="form-control required" placeholder="Enter full name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Gender:</strong></label>
                <select className='form-control required' id="gender" name="gender">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["gender"]==="Male"} value={"Male"}>Male</option>
                    <option selected={props.memberProfile[0]["gender"]==="Female"} value={"Female"}>Female</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Date of Birth:</strong></label>
                <TableDatePicker refDate={props.memberProfile[0]["fmt_dob"]} class="form-control required" refName="dob"/>
                {/* <input name="date_of_birth" type="date" class="form-control required" /> */}
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Time:</strong></label>
                <input name="time" id="time" type="time" defaultValue={props.memberProfile[0]["fmt_time"]} class="form-control required" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Place:</strong></label>
                <input name="birth_place" defaultValue={props.memberProfile[0]["birth_place"]} id="birth_place" type="text" class="form-control required" placeholder="Enter birth place" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Height (in cm):</strong></label>
                <input name="height" id="height" defaultValue={props.memberProfile[0]["height"]} type="number" class="form-control required" placeholder="Enter height" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Skin Colour:</strong></label>
                <select className='form-control required' id="skin_color" name="skin_color">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["skin_color"]==="Fair"} value={"Fair"}>Fair</option>
                    <option selected={props.memberProfile[0]["skin_color"]==="Light"} value={"Light"}>Light</option>
                    <option selected={props.memberProfile[0]["skin_color"]==="Medium"} value={"Medium"}>Medium</option>
                    <option selected={props.memberProfile[0]["skin_color"]==="Dark"} value={"Dark"}>Dark</option>
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Highest Qualification:</strong></label>
                <select className='form-control required' id="max_qualification" name="max_qualification">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="12th"} value={"12th"}>12th</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Graduation"} value={"Graduation"}>Graduation</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Post Graduation"} value={"Post Graduation"}>Post Graduation</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Engineering"} value={"Engineering"}>Engineering</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Medicine"} value={"Medicine"}>Medicine</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Law"} value={"Law"}>Law</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Management"} value={"Management"}>Management</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Doctor"} value={"Doctor"}>Doctor</option>
                    <option selected={props.memberProfile[0]["max_qualification"]==="Other Diploma"} value={"Other Diploma"}>Other Diploma</option>
                </select>
                
            </div>
           
        </div>
    
        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Highest Qualification Details:</strong></label>
            <input name="max_qualification_det" defaultValue={props.memberProfile[0]["max_qualification_det"]} id="max_qualification_det" type="text" class="form-control required" placeholder="Enter Qualification Degree/College/University Name" required/>
        </div>

        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Occupation:</strong></label>
            <input name="occupation" id="occupation" defaultValue={props.memberProfile[0]["occupation"]} type="text" class="form-control required" placeholder="Enter occupation"/>
        </div>
        <div class="row">
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>State:</strong></label>
            <select className='form-control required' id="state_nm" name="state_nm">
                    <option value={"0"}>-Select-</option>
                    {props.stateList.map((item,index)=>{
                        return <option selected={props.memberProfile[0]["state_nm"]===item["name"]} value={item["name"]}>{item["name"]}</option>
                    })}
                  
                </select>
        </div>
        

        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>City:</strong></label>
            <input type='text' name="city_nm" id="city_nm" defaultValue={props.memberProfile[0]["city_nm"]} class="form-control required" placeholder='City Name' />
        </div>
        <div class="col-md-12 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Address:</strong></label>
            <textarea name="address" id="address" defaultValue={props.memberProfile[0]["address"]} class="form-control required" placeholder="Enter full address" rows="2" required></textarea>
        </div>
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Landmark:</strong></label>
            <input type='text' name="landmark" id="landmark" defaultValue={props.memberProfile[0]["landmark"]} class="form-control required" placeholder='Landmark' />
        </div>

        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Pincode:</strong></label>
            <input type='text' name="pincode" id="pincode" defaultValue={props.memberProfile[0]["pincode"]} class="form-control required" placeholder='Pincode' />
        </div>

        </div>

        

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mobile No.:</strong></label>
                <input name="contact_no" id="contact_no" defaultValue={props.memberProfile[0]["contact_no"]} type="tel"  class="form-control required" placeholder="Enter mobile number" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Email ID:</strong></label>
                <input name="email" id="email" type="email" defaultValue={props.memberProfile[0]["email_id"]} class="form-control required" placeholder="Enter email address"/>
            </div>
        </div>

        <h4 class="mt-4">Family Details</h4>

        <div class="row">
        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Name:</strong></label>
                <input name="father_nm" id="father_nm" defaultValue={props.memberProfile[0]["father_nm"]} type="text" class="form-control required" placeholder="Enter father's name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mother's Name:</strong></label>
                <input name="mother_name" id="mother_name" defaultValue={props.memberProfile[0]["mother_name"]} type="text" class="form-control required" placeholder="Enter mother's name" required/>
            </div>
           
        
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Occupation:</strong></label>
                <input name="father_occup" id="father_occup" defaultValue={props.memberProfile[0]["father_occup"]} type="text" class="form-control required" placeholder="Enter father's occupation"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Mobile No.:</strong></label>
                <input name="father_contact" id="father_contact" defaultValue={props.memberProfile[0]["father_contact"]} type="tel" class="form-control required" placeholder="Enter father's mobile"/>
            </div>
            <div class="row">
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Occupation:</strong></label>
                    <input name="mother_occup" id="mother_occup" type="text" defaultValue={props.memberProfile[0]["mother_occup"]} class="form-control required" placeholder="Enter mother's occupation"/>
                </div>
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Mobile No.:</strong></label>
                    <input name="mother_contact" id="mother_contact" type="tel" defaultValue={props.memberProfile[0]["mother_contact"]} class="form-control required" placeholder="Enter mother's mobile"/>
                </div>
            </div>
        </div>

        <h4 class="mt-4">Income</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Family Annual Income:</strong></label>
                
                <select className='form-control required' id="family_anum" name="family_anum">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="6.00"} value={"6"}>5 to 6 lac per year</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="8.00"} value={"8"}>6 to 8 lac per year</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="10.00"} value={"10"}>8 to 10 lac per year</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="15.00"} value={"15"}>10 to 15 lac per year</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="20.00"} value={"20"}>15 to 20 lac per year</option>
                    <option selected={props.memberProfile[0]["family_anum"]==="40.00"} value={"40"}>30 to 40 lac per year</option>
                    
                    <option selected={props.memberProfile[0]["family_anum"]==="41.00"} value={"41"}>Greater than 40 lac per year</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Annual Income:</strong></label>
                <select className='form-control required' id="self_anum" name="self_anum">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="6.00"} value={"6"}>5 to 6 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="8.00"} value={"8"}>6 to 8 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="10.00"} value={"10"}>8 to 10 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="15.00"} value={"15"}>10 to 15 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="20.00"} value={"20"}>15 to 20 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="40.00"} value={"40"}>30 to 40 lac per year</option>
                    <option selected={props.memberProfile[0]["self_anum"]==="41.00"} value={"41"}>Greater than 40 lac per year</option>
                </select>
                {/* <input name="self_anum" id="self_anum" type="number" class="form-control required" placeholder="Self Annual Income"/> */}
            </div>
        </div>

        <h4 class="mt-4">Goutra</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Goutra:</strong></label>
                <select className='form-control required' id="self_goutra" name="self_goutra">
                    <option value={"0"}>-Select-</option>
                    {props.gotraList.map((item,index)=>{
                        return <option selected={props.memberProfile[0]["self_goutra"]===item["temple_name"]} value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Goutra:</strong></label>
                <select className='form-control required' id="mama_goutra" name="mama_goutra">
                    <option value={"0"}>-Select-</option>
                    {props.gotraList.map((item,index)=>{
                        return <option selected={props.memberProfile[0]["mama_goutra"]==item["temple_name"]} value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
            </div>
        </div>
        {/* <h4 class="mt-4">Kuldevi</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Kuldevi:</strong></label>
                <input name="kuldevi_self" type="text" class="form-control" placeholder="Enter Kuldevi"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Kuldevi:</strong></label>
                <input name="kuldevi_mama" type="tel" class="form-control" placeholder="Enter Mama Kuldevi"/>
            </div>
        </div> */}
        <h4 class="mt-4">Mangalic Status</h4>
        <div class="row">
        <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Mangalic Status:</strong></label>
                <select id="mangalic_status" name="mangalic_status" class="form-control select">
                    <option value={"0"}>Select</option>
                    <option selected={props.memberProfile[0]["mangalic_status"]==="Mangalic"} value={"Mangalic"}>Mangalic</option>
                    <option selected={props.memberProfile[0]["mangalic_status"]==="Anshik Mangalic"} value={"Anshik Mangalic"}>Anshik Mangalic</option>
                    <option selected={props.memberProfile[0]["mangalic_status"]==="General"} value={"General"}>General</option>
                    
                </select>
                
            </div>
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Marital Status:</strong></label>
                <select id="marital_status" name="marital_status" class="form-control">
                    <option value={"0"}>Select</option>
                    {/* <option value={"Married"}>Married</option> */}
                    <option selected={props.memberProfile[0]["marital_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={props.memberProfile[0]["marital_status"]==="Divorced"} value={"Divorced"}>Divorced</option>
                    <option selected={props.memberProfile[0]["marital_status"]==="Widow (विधवा)"} value={"Widow (विधवा)"}>Widow (विधवा)</option>
                    <option selected={props.memberProfile[0]["marital_status"]==="Widower (विधुर)"} value={"Widower (विधुर)"}>Widower (विधुर)</option>
                    
                </select>
               
            </div>
        </div>
        <h4 class="mt-4">Siblings Details</h4>
        <div class="row">
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_status"><strong>Brother *:</strong></label>
                <select id="brother_status" name="brother_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="No Brother"} value={"No Brother"}>No Brother</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="Married"} value={"Married"}>Married</option>
                </select>
                <input name="brother_det" id="brother_det" defaultValue={props.memberProfile[0]["brother_det"]} type="text" class="form-control mt-1" placeholder="Enter details if Brother is Married"/>
            </div>
    
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="sister_status"><strong>Sister:</strong></label>
                <select id="sister_status" name="sister_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="No Sister"} value={"No Sister"}>No Sister</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={props.memberProfile[0]["brother_status"]==="Married"} value={"Married"}>Married</option>
                </select>
                <input name="sister_det" id="sister_det" defaultValue={props.memberProfile[0]["sister_det"]} type="text" class="form-control mt-1" placeholder="Enter details if Sister is Married"/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Name:</strong></label>
                <input name="ref_one_nm" readOnly={"true"} id="ref_one_nm" defaultValue={props.memberProfile[0]["ref_one_nm"]} type="text"  class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Contact:</strong></label>
                <input name="ref_one_contact" readOnly={"true"} id="ref_one_contact" defaultValue={props.memberProfile[0]["ref_one_contact"]} type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Name:</strong></label>
                <input name="ref_two_nm" readOnly={"true"} id="ref_two_nm" defaultValue={props.memberProfile[0]["ref_two_nm"]} type="text" class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Contact:</strong></label>
                <input name="ref_two_contact" readOnly={"true"} id="ref_two_contact" defaultValue={props.memberProfile[0]["ref_two_contact"]} type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>

            {/* <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="registered_by"><strong>Registered By:</strong></label>
                <select id="registered_by" name="registered_by" class="form-control required">
                    <option>Select</option>
                    <option selected={stMyProfile[0]["registered_by"]==="Self"} value={"Self"}>Self</option>
                    <option selected={stMyProfile[0]["registered_by"]==="Parents"} value={"Parents"}>Parents</option>
                    
                    
                </select>
                
            </div> */}
        </div>

        <div class="text-center mt-4">
            <button type="button" onClick={()=>updMemeberReq()} class="btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>:''}
          </div>
          </div>
          </div>
          </div>);
    
}
export default Comp_Edit_Matri_Member;
